'use strict';

const toggleMobileNavigation = function () {
    $('body').toggleClass('mobile-nav-open');
    $('.modal-background').toggleClass('open');
};

// The site header is sticky and stays in normal flow. Drop any inline
// padding-top left over from the fixed-header offset, which showed as a
// white band under the navigation.
var calculateMainSectionPadding = function () {
    $('.main-content').css('padding-top', '');
};

var mobileNavQuery = window.matchMedia('(max-width: 991.98px)');

function isMobileNav() {
    return mobileNavQuery.matches;
}

// Ctrl/Cmd-click, middle-click and right-click leave the page in place, so the
// pressed label keeps focus and :focus-within pins the panel open.
function isPinningPointer(event) {
    return event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;
}

function setPanelSlotsOffset(dropdown) {
    if (!dropdown) {
        return;
    }
    var slots = dropdown.querySelector('.nav-menu__slots');
    var height = 0;
    if (slots && window.getComputedStyle(slots).display !== 'none') {
        height = slots.offsetHeight;
    }
    dropdown.style.setProperty('--nav-panel-slots', height + 'px');
}

function setMobileNavTop() {
    var $bar = $('.js-nav-mobile-bar');

    if (!$bar.length) {
        return;
    }

    var top = $bar.offset().top - $(window).scrollTop();
    document.documentElement.style.setProperty('--nav-mobile-top', top + 'px');
    document.querySelectorAll('.nav-menu__dropdown').forEach(setPanelSlotsOffset);
}

function placeLocaleInMenu() {
    var locale = document.querySelector('.nav-menu__locale');
    var menu = document.querySelector('.nav-menu');
    var panel = locale && locale.querySelector('.js-nav-locale-panel');
    var nav = locale && locale.parentElement;
    if (!locale || !menu || !nav || menu.contains(locale)) {
        return;
    }
    if (panel) {
        nav.appendChild(panel);
    }
    menu.appendChild(locale);
}

function setLocalePanelOpen(isOpen) {
    var $panel = $('.js-nav-locale-panel');
    $panel.toggleClass('is-open', isOpen);
    $panel.attr('aria-hidden', isOpen ? 'false' : 'true');
    $panel.prop('inert', !isOpen);
    $('.js-nav-locale-open').attr('aria-expanded', isOpen ? 'true' : 'false');
}

function recoverSlotImage(img) {
    var fallback = img.getAttribute('data-fallback');
    if (!fallback) {
        return;
    }
    img.removeAttribute('data-fallback');
    img.src = fallback;
}

function recoverSlotImages() {
    document.querySelectorAll('.nav-menu__slots img[data-fallback]').forEach(function (img) {
        if (img.complete && img.naturalWidth === 0) {
            recoverSlotImage(img);
        }
    });
}

document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.closest || !img.closest('.nav-menu__slots')) {
        return;
    }
    recoverSlotImage(img);
}, true);

function showMobileCategorySlots() {
    recoverSlotImages();
}

var mobileNavLoaderTimer = null;

function stopMobileNavLoader() {
    clearTimeout(mobileNavLoaderTimer);
    mobileNavLoaderTimer = null;
    $('#header-nav-mobile').spinner().stop();
}

function setLevelOneCovered(covered) {
    $('.nav-menu__slots-dock, .nav-menu__locale-banner')
        .prop('inert', covered)
        .attr('aria-hidden', covered ? 'true' : 'false');
}

function closeMobileNav() {
    stopMobileNavLoader();
    setLocalePanelOpen(false);
    $('body').removeClass('mobile-nav-open');
    $('.nav-menu__item.is-open').removeClass('is-open');
    setLevelOneCovered(false);
    showMobileCategorySlots();
    $('.nav-bar .js-nav-toggle').attr('aria-expanded', 'false');
}

function startMobileNavLoader() {
    if (mobileNavLoaderTimer) {
        return;
    }

    $('#header-nav-mobile').spinner().start();
    mobileNavLoaderTimer = setTimeout(closeMobileNav, 1000);
}

function openMobileNav() {
    $(window).scrollTop(0);
    $('body').addClass('mobile-nav-open');
    setMobileNavTop();
    $('.nav-bar .js-nav-toggle').attr('aria-expanded', 'true');

    var $first = $('#header-nav-mobile').find('a, button').filter(':visible').first();
    if ($first.length) {
        $first.trigger('focus');
    }
}

module.exports = function () {
    placeLocaleInMenu();
    recoverSlotImages();
    calculateMainSectionPadding();
    $(window).resize(function () {
        calculateMainSectionPadding();
        if ($('body').hasClass('mobile-nav-open')) {
            setMobileNavTop();
        }
    });

    $('body').on('click', '.js-nav-toggle', function () {
        if ($('body').hasClass('mobile-nav-open')) {
            closeMobileNav();
            $('.nav-bar .js-nav-toggle').trigger('focus');
        } else {
            openMobileNav();
        }
    });

    $('body').on('click', '.js-nav-overlay', function () {
        closeMobileNav();
        $('.nav-bar .js-nav-toggle').trigger('focus');
    });

    $('body').on('click', '.js-nav-locale-open', function () {
        setLocalePanelOpen(true);
        $('.js-nav-locale-close').trigger('focus');
    });

    $('body').on('click', '.js-nav-locale-close', function () {
        setLocalePanelOpen(false);
        $('.js-nav-locale-open').trigger('focus');
    });

    // A drag that ends on the overlay leaves :hover stuck on the pressed label.
    $('body').on('dragstart', '.nav-menu__item--level-1 > .nav-menu__item-text', function (event) {
        event.preventDefault();
    });

    var pinningFocus = false;

    $('body').on('pointerdown', '.nav-menu a, .nav-menu__item--level-1 > .nav-menu__item-text', function (event) {
        pinningFocus = isPinningPointer(event);
    });

    $('body').on('keydown', function (event) {
        if (event.key === 'Tab') {
            pinningFocus = false;
        }
    });

    // Releasing outside the pressed item, or a ctrl / middle / right click on it,
    // leaves focus behind. Blur so the panel closes. Tab still opens it.
    $('body').on('pointerup', function (event) {
        if (isMobileNav()) {
            return;
        }

        var active = document.activeElement;
        if (!active || !active.closest) {
            return;
        }

        var item = active.closest('.nav-menu__item--level-1');
        if (!item || (item.contains(event.target) && !isPinningPointer(event))) {
            return;
        }

        active.blur();
    });

    // The context menu can focus the label again after pointerup.
    $('body').on('focusin', '.nav-menu a, .nav-menu__item--level-1 > .nav-menu__item-text', function () {
        if (!pinningFocus || isMobileNav()) {
            return;
        }

        var el = this;
        setTimeout(function () {
            if (document.activeElement === el) {
                el.blur();
            }
        }, 0);
    });

    $('body').on('keydown', '.nav-menu__item--has-children > span', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        event.preventDefault();
        $(this).trigger('click');
    });

    $('body').on('click', '.nav-menu__item--has-children > a, .nav-menu__item--has-children > span', function (event) {
        if (!isMobileNav()) {
            return;
        }

        event.preventDefault();
        var $item = $(this).parent();
        $item.siblings('.is-open').removeClass('is-open');
        $item.addClass('is-open');
        if ($item.hasClass('nav-menu__item--level-1')) {
            setLevelOneCovered(true);
            showMobileCategorySlots();
            setPanelSlotsOffset($item.children('.nav-menu__dropdown').get(0));
        }
    });

    $('body').on('click', '.js-nav-back', function (event) {
        event.preventDefault();
        var $item = $(this).closest('.nav-menu__item.is-open');
        var backToRoot = $item.hasClass('nav-menu__item--level-1');
        $item.removeClass('is-open');
        if (backToRoot) {
            setLevelOneCovered(false);
            showMobileCategorySlots();
        }
    });

    $('body').on('click', '#header-nav-mobile a[href]', function (event) {
        if (!isMobileNav() || event.isDefaultPrevented()) {
            return;
        }

        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.which === 2) {
            return;
        }

        var href = $(this).attr('href');
        if (!href || href.charAt(0) === '#' || $(this).attr('target') === '_blank') {
            return;
        }

        startMobileNavLoader();
    });

    $(document).on('keydown', function (event) {
        if (event.key !== 'Escape' || !$('body').hasClass('mobile-nav-open')) {
            return;
        }

        if ($('.js-nav-locale-panel').hasClass('is-open')) {
            setLocalePanelOpen(false);
            $('.js-nav-locale-open').trigger('focus');
            return;
        }

        closeMobileNav();
        $('.nav-bar .js-nav-toggle').trigger('focus');
    });

    $('.dropdown a.active').each(function () {
        const $parent = $(this).parents('.dropdown');
        $parent.find('.dropdown-toggle').text($(this).text());
    });

    $('.mega-menu__item')
        .on('mouseenter', function () {
            $(this).addClass('mega-menu_open');
            $(this)
                .find('.mega-menu__sub')
                .attr('aria-expanded', true);
        })
        .on('mouseleave', function () {
            $(this).removeClass('mega-menu_open');
            $(this)
                .find('.mega-menu__sub')
                .attr('aria-expanded', false);
        });

    $('body').on('click', '.modal-background', function () {
        if ($('body').hasClass('mobile-nav-open')) {
            toggleMobileNavigation();
        }
    });

    $('[data-toggle="slide-collapse"]').on('click', function () {
        if (!$('body').hasClass('mobile-nav-open')) {
            $(window).scrollTop(0);
        }

        toggleMobileNavigation();
    });

    $('.mobile-nav-forward').on('click', function () {
        $(this)
            .siblings('.level-2, .level-3')
            .addClass('active');
    });

    $('.mobile-nav-previous').on('click', function () {
        $(this)
            .closest('.level-2, .level-3')
            .removeClass('active');
    });

    $('body').on('calculatemainsection', calculateMainSectionPadding);
};

const siteHeaderHeight = $('.site-header').height();
const $body = $('body');
if ($body.hasClass('permanent-sticky')) {
    $(window).on('load', calculateMainSectionPadding);
} else {
    $(window).on('load', function () {
        calculateMainSectionPadding();

        $(window).on('scroll', function () {
            if ($(this).scrollTop() > siteHeaderHeight) {
                $body.addClass('minify-header');
            } else {
                $body.removeClass('minify-header');
            }
            calculateMainSectionPadding();
        });
    });
}
$(window).trigger('scroll');
